import { createContext, useContext, useState, ReactNode } from "react";

type ExpandedType = "none" | "map" | string; // string for machine card IDs

interface LocationDetailResizeContextType {
  expandedComponent: ExpandedType;
  toggleMapExpanded: () => void;
  toggleMachineExpanded: (machineId: string) => void;
}

const LocationDetailResizeContext = createContext<LocationDetailResizeContextType | undefined>(undefined);

export const LocationDetailResizeProvider = ({ children }: { children: ReactNode }) => {
  const [expandedComponent, setExpandedComponent] = useState<ExpandedType>("none");

  const toggleMapExpanded = () => {
    setExpandedComponent((prev) => (prev === "map" ? "none" : "map"));
  };

  const toggleMachineExpanded = (machineId: string) => {
    setExpandedComponent((prev) => (prev === machineId ? "none" : machineId));
  };

  return (
    <LocationDetailResizeContext.Provider
      value={{ expandedComponent, toggleMapExpanded, toggleMachineExpanded }}
    >
      {children}
    </LocationDetailResizeContext.Provider>
  );
};

export const useLocationDetailResize = () => {
  const context = useContext(LocationDetailResizeContext);
  if (context === undefined) {
    throw new Error("useLocationDetailResize must be used within LocationDetailResizeProvider");
  }
  return context;
};
